import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=194373dc&scoped=true"
import script from "./QuestionsSection.vue?vue&type=script&lang=ts"
export * from "./QuestionsSection.vue?vue&type=script&lang=ts"
import style0 from "./QuestionsSection.vue?vue&type=style&index=0&id=194373dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194373dc",
  null
  
)

export default component.exports